import { render, staticRenderFns } from "./big-value-widget.vue?vue&type=template&id=a61f9c70&scoped=true&"
import script from "./big-value-widget.vue?vue&type=script&lang=js&"
export * from "./big-value-widget.vue?vue&type=script&lang=js&"
import style0 from "./big-value-widget.vue?vue&type=style&index=0&id=a61f9c70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61f9c70",
  null
  
)

export default component.exports